/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentDto } from './PaymentDto';
import {
    PaymentDtoFromJSON,
    PaymentDtoFromJSONTyped,
    PaymentDtoToJSON,
    PaymentDtoToJSONTyped,
} from './PaymentDto';

/**
 * 
 * @export
 * @interface GetPaymentsResponse
 */
export interface GetPaymentsResponse {
    /**
     * Type de quittance, déjà libellé par le back : « Comptant », « Terme », « Sinistre » ou « Résiliation ». Chaîne prête à afficher, aucun code à traduire — un contrat nouvellement souscrit est toujours en « Comptant ».
     * @type {string}
     * @memberof GetPaymentsResponse
     */
    receiptType?: string | null;
    /**
     * 
     * @type {Array<PaymentDto>}
     * @memberof GetPaymentsResponse
     */
    payments: Array<PaymentDto>;
}

/**
 * Check if a given object implements the GetPaymentsResponse interface.
 */
export function instanceOfGetPaymentsResponse(value: object): value is GetPaymentsResponse {
    if (!('payments' in value) || value['payments'] === undefined) return false;
    return true;
}

export function GetPaymentsResponseFromJSON(json: any): GetPaymentsResponse {
    return GetPaymentsResponseFromJSONTyped(json, false);
}

export function GetPaymentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPaymentsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'receiptType': json['receiptType'] == null ? undefined : json['receiptType'],
        'payments': ((json['payments'] as Array<any>).map(PaymentDtoFromJSON)),
    };
}

export function GetPaymentsResponseToJSON(json: any): GetPaymentsResponse {
    return GetPaymentsResponseToJSONTyped(json, false);
}

export function GetPaymentsResponseToJSONTyped(value?: GetPaymentsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'receiptType': value['receiptType'],
        'payments': ((value['payments'] as Array<any>).map(PaymentDtoToJSON)),
    };
}

